<div class="container" data-cy="courtesy_vehicle_agreement_page" *ngIf="booking">
  <page-title [showArrow]="false" text="AGREEMENTS_SIGN_TITLE" (backChange)="navigateBack()"></page-title>
  <courtesy-vehicle-extra [chooseExtra]="chooseExtra"></courtesy-vehicle-extra>
  <button type="button" class="btn mt-20" data-cy="send" (click)="send()" [disabled]="!canSave()">
    {{"AGREEMENT_SEND" | translate}}
    <i *ngIf="sendInProgress" class="fa fa-spinner fa-spin"></i>
  </button>
</div>
